import React from "react"
import { ChevronRight } from "@material-ui/icons"
import { NavLink } from "react-router-dom"
import { Trans } from "@lingui/macro"
import { ActionCard } from "."
import { useKnowledgeUtils } from "../../utils"

const KnowledgeActionCard = ({ knowledge: { id, title } }) => {
  const { getNavigateToArticleLinkForID } = useKnowledgeUtils()

  return (
    <ActionCard
      key={id}
      title={title}
      detail={<Trans>Knowledge base article</Trans>}
      cardProps={{ component: NavLink, to: { pathname: getNavigateToArticleLinkForID(id) } }}
      rightChildren={<ChevronRight />}
    />
  )
}

export { KnowledgeActionCard }
